import { Component } from '@angular/core';

@Component({
  selector: 'app-no-details',
  templateUrl: './no-details.component.html',
  styleUrls: ['./no-details.component.css']
})
export class NoDetailsComponent {
}
